import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { useAppSelector } from "store/hooks"
import { UITypes } from "types"

import { getRoundedTemperature } from "utils/getRoundedTemperature"
import parseCelsiusToFahrenheit from "utils/parseCelsiusToFahrenheit"
const Container = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #0f172a;
`

interface PerformanceTestTempChangeProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const TempChangeOfPerformanceTest = ({ cell: { row } }: PerformanceTestTempChangeProps) => {
  const userTemperatureScale = useAppSelector(state => state.user.userTemperatureScale)
  const temperatureMark = userTemperatureScale === "celsius" ? "C" : "F"

  const { start_temp, end_temp } = row.original.temp_change.value as { start_temp: number; end_temp: number }

  if (!start_temp || !end_temp) return null

  const parsedStartTemp = userTemperatureScale === "celsius" ? start_temp : parseCelsiusToFahrenheit(start_temp)
  const parsedEndTemp = userTemperatureScale === "celsius" ? end_temp : parseCelsiusToFahrenheit(end_temp)

  return (
    <Container>
      From {getRoundedTemperature(parsedStartTemp, 1, true)} {temperatureMark} to{" "}
      {getRoundedTemperature(parsedEndTemp, 1, true)} {temperatureMark}
    </Container>
  )
}
